import { render } from "./UiTab.vue?vue&type=template&id=71e9b215"
import script from "./UiTab.vue?vue&type=script&lang=js"
export * from "./UiTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__